module.exports = __webpack_public_path__ + "static/media/icon-1.1a2ce6fe.png";